module.exports = __webpack_public_path__ + "static/img/0004-test.f65469a1.png";